/**
 * Created by yniran on 12/15/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        BaseModel = require("models/BaseModel"),
        ChatContactModel = {};
    var KEYS = {
        CONVERSATION_TYPE: "engagementType",
        CONTACT_TYPE: "contactType",
        AVAILABILITY: "availability",
        BACKUP_AVAILABILITY: "backupAvailability",
        CONTEXT_ID: "contextId",
        DISPLAY_NAME: "displayName",
        IMAGE: "img",
        NOTIFICATION_COUNTER: "notificationCounter",
        HIDDEN: "hidden",
        BACKUPSKILL_NAME: "backupSkillName",
        SKILL_NAME: "skillName",
        SKILL_ID: "skillId",
        ENGAGEMENT_ID: "engagementId",
        CAMPAIGN_ID: "campaignId",
        AUTHCONN_ID: "authConnId",
        CONNECTOR: "connector",
        MSG_CONV_LOADED: "isMessagingConversationLoaded",
        OWN_ID: "ownId",
        AUTH_REQUESTED: "auth_requested" // flag that authentication was required for this model
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ChatContactModel = BaseModel.extend({
            name: "ChatContactModel",
            idAttribute: 'skillName',
            defaults: {
                availability: false,
                backupAvailability: false,
                connector: 1, //=== oauth implicit
                isMessagingContactReady: false,
                isMessagingConversationLoaded: false,
                auth_requested: false,
                engagementType: CP_CONST.CONVERSATION_TYPES.CHAT
            },

            init: function () {
                this._initImg();
                this._initContactType();
            },

            getFilterInfo: function () {
                return this.collection.getFilterInfo();
            },

            getMessagingConversationLoaded: function () {
                return this.get(KEYS.MSG_CONV_LOADED);
            },

            setMessagingConversationLoaded: function (loaded) {
                this.set(KEYS.MSG_CONV_LOADED, loaded);
            },

            isMessagingContact: function () {
                return this.get(KEYS.CONVERSATION_TYPE) === CP_CONST.CONVERSATION_TYPES.MESSAGING;
            },

            isGroup: function () {
                return this.get(KEYS.CONTACT_TYPE) === CP_CONST.CONTACT_TYPE.GROUP;
            },

            isUser: function () {
                return this.get(KEYS.CONTACT_TYPE) === CP_CONST.CONTACT_TYPE.USER;
            },

            isPSGContact: function () {
                return this.isUser();
            },

            getAvailability: function () {
                return this.get(KEYS.AVAILABILITY);
            },

            getBackupAvailability: function () {
                return this.get(KEYS.BACKUP_AVAILABILITY);
            },

            setBackupAvailability: function (availability) {
                this.set(KEYS.BACKUP_AVAILABILITY, availability);
            },

            setOwnId: function (participants) {
                if (participants.CONSUMER) {
                    this.set(KEYS.OWN_ID, participants.CONSUMER[0]);
                } else {
                    this.set(KEYS.OWN_ID, participants.READER[0]);
                }
            },

            getOwnId: function () {
                return this.get(KEYS.OWN_ID);
            },

            getBackupSkillName: function () {
                return this.get(KEYS.BACKUPSKILL_NAME);
            },

            getContextId: function () {
                return this.get(KEYS.CONTEXT_ID);
            },

            getDisplayName: function () {
                return this.get(KEYS.DISPLAY_NAME);
            },

            getNotificationCounter: function () {
                return this.get(KEYS.NOTIFICATION_COUNTER) || 0;
            },

            getSkillName: function () {
                return this.get(KEYS.SKILL_NAME);
            },

            getSkillId: function () {
                return this.get(KEYS.SKILL_ID);
            },

            getEngagementId: function () {
                return this.get(KEYS.ENGAGEMENT_ID);
            },

            getCampaignId: function () {
                return this.get(KEYS.CAMPAIGN_ID);
            },

            getAuthConnId: function () {
                return this.get(KEYS.AUTHCONN_ID);
            },

            getConnector: function () {
                return this.get(KEYS.CONNECTOR);
            },

            resetNotificationsCounter: function () {
                this.set(KEYS.NOTIFICATION_COUNTER, 0);
            },

            isHidden: function () {
                var hidden = this.get(KEYS.HIDDEN);
                if (!_.isUndefined(hidden) && !_.isNull(hidden) && _.isBoolean(hidden)) {
                    return hidden === true;
                }
                return false;
            },

            _initImg: function () {
                if (_.isEmpty(this.get(KEYS.IMAGE))) {
                    this.set(KEYS.IMAGE, CP_CONST.CONTACT_DEFAULT_AVATAR);
                }
            },

            _initContactType: function () {
                if( _.isUndefined(this.get(KEYS.CONTACT_TYPE))){
                    if(this.get(KEYS.CONVERSATION_TYPE)===CP_CONST.CONVERSATION_TYPES.MESSAGING){
                        this.set(KEYS.CONTACT_TYPE, CP_CONST.CONTACT_TYPE.USER);
                    }
                    if(this.get(KEYS.CONVERSATION_TYPE)===CP_CONST.CONVERSATION_TYPES.CHAT){
                        this.set(KEYS.CONTACT_TYPE, CP_CONST.CONTACT_TYPE.GROUP);
                    }
                }
            }
        });
    });
    ChatContactModel.KEYS = KEYS;

    return ChatContactModel;
});
